import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  IDjecfjjw6mot9 as ID,
  ID1z61wlmtvxrjn as ID_0,
  ID1m87d1hextx54 as ID_1,
  Employer27b20p5x27kte as Employer,
  Grant2zfdfpt9q1mly as Grant,
  Family2k7vz7ddyergb as Family,
  CareLocation1v3u5wduz023s as CareLocation,
  CareProvider2qcawrqluyllr as CareProvider,
  IDqqik72jjbpsn as ID_2,
  ID1lyj7m2ox8cp5 as ID_3,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  IDknm0szoty74n as ID_4,
  _ID___init__impl__k1lb7e34qbnsrrpttnl as _ID___init__impl__k1lb7e,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get__id1hi7gtah39onn as get__id,
  get__idsxxkn2fqoor7 as get__id_0,
  get__id336i6k806byxy as get__id_1,
  get__id2p9nbcwbj0zlw as get__id_2,
  get__id1301miildb0kq as get__id_3,
  get__id1elsu38391a1o as get__id_4,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  sortedWith2csnbbb21k0lg as sortedWith,
  plus310ted5e4i90h as plus,
  plus20p0vtfmu0596 as plus_0,
  asSequence2phdjljfh9jhx as asSequence,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  compareValues1n2ayl87ihzfk as compareValues,
  compareBy2697bq0ffft96 as compareBy,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { BilledDayTotals2enuwcjtkow7 as BilledDayTotals } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { coroutineScope2qhrb6lhutwsn as coroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
  Cents1lsbs5l1tlgw as Cents,
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  _Cents___get_inCents__impl__osbjn36wwmf018zvn3 as _Cents___get_inCents__impl__osbjn,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { sequenceOfdrc6uefhtiet as sequenceOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { plus2l6bq32n2wlna as plus_1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { appendCsvRows26y51byhnrjfx as appendCsvRows } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvConfig.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from './SingleDaysPage.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabeledViewseav57tyecmf as LabeledView,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { Align_End_getInstancer37lklmdzqms as Align_End_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tableWithSticky1958em9ua7p76 as tableWithSticky,
} from '../components/table.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_1,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  ReportFiltersigb451dg4asm as ReportFilters,
  reportFilterMenu2u8jz7auzgjn6 as reportFilterMenu,
  reportFilterBar2ow9csmm0mu97 as reportFilterBar,
} from './ReportFilters.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { h12aidul0n4qlwh as h1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { exportButton1ekt3fxzrhh34 as exportButton } from '../components/view-utilities.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function DayGrouping$Companion$_anonymous__79ve7k() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.reports.DayGrouping', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  DayGrouping_Family_instance = new (DayGrouping())('Family', 0, 'Family');
  DayGrouping_AgeGroup_instance = new (DayGrouping())('AgeGroup', 1, 'Age group');
  DayGrouping_Location_instance = new (DayGrouping())('Location', 2, 'Location');
  DayGrouping_Provider_instance = new (DayGrouping())('Provider', 3, 'Provider');
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var DayGrouping_Family_instance;
var DayGrouping_AgeGroup_instance;
var DayGrouping_Location_instance;
var DayGrouping_Provider_instance;
function values() {
  static_init();
  return [DayGrouping_Family_getInstance(), DayGrouping_AgeGroup_getInstance(), DayGrouping_Location_getInstance(), DayGrouping_Provider_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, DayGrouping$Companion$_anonymous__79ve7k);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var DayGroupingClass;
function DayGrouping() {
  if (DayGroupingClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'DayGrouping', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    DayGroupingClass = $;
  }
  return DayGroupingClass;
}
var RowClass;
function Row() {
  if (RowClass === VOID) {
    class $ {
      constructor(label, totals, drillDown) {
        this.label_1 = label;
        this.totals_1 = totals;
        this.drillDown_1 = drillDown;
      }
      toString() {
        return 'Row(label=' + this.label_1 + ', totals=' + this.totals_1.toString() + ', drillDown=' + toString(this.drillDown_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.label_1);
        result = imul(result, 31) + this.totals_1.hashCode() | 0;
        result = imul(result, 31) + (this.drillDown_1 == null ? 0 : this.drillDown_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Row()))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!this.totals_1.equals(other.totals_1))
          return false;
        if (!equals(this.drillDown_1, other.drillDown_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Row');
    RowClass = $;
  }
  return RowClass;
}
var PayerClass;
function Payer() {
  if (PayerClass === VOID) {
    class $ {
      constructor(name, paid, narrow) {
        this.name_1 = name;
        this.paid_1 = paid;
        this.narrow_1 = narrow;
      }
    }
    initMetadataForClass($, 'Payer');
    PayerClass = $;
  }
  return PayerClass;
}
var ReportClass;
function Report() {
  if (ReportClass === VOID) {
    class $ {
      constructor(rows, payers) {
        this.rows_1 = rows;
        this.payers_1 = payers;
      }
      toString() {
        return 'Report(rows=' + toString_0(this.rows_1) + ', payers=' + toString_0(this.payers_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.rows_1);
        result = imul(result, 31) + hashCode(this.payers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Report()))
          return false;
        if (!equals(this.rows_1, other.rows_1))
          return false;
        if (!equals(this.payers_1, other.payers_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Report');
    ReportClass = $;
  }
  return ReportClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var DayTotalsPage$render$GroupClass;
function DayTotalsPage$render$Group() {
  if (DayTotalsPage$render$GroupClass === VOID) {
    class $ {
      constructor(label, drillDown, order) {
        order = order === VOID ? 0 : order;
        this.label_1 = label;
        this.drillDown_1 = drillDown;
        this.order_1 = order;
      }
      toString() {
        return 'Group(label=' + this.label_1 + ', drillDown=' + toString(this.drillDown_1) + ', order=' + this.order_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.label_1);
        result = imul(result, 31) + (this.drillDown_1 == null ? 0 : this.drillDown_1.hashCode()) | 0;
        result = imul(result, 31) + this.order_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DayTotalsPage$render$Group()))
          return false;
        if (!(this.label_1 === other.label_1))
          return false;
        if (!equals(this.drillDown_1, other.drillDown_1))
          return false;
        if (!(this.order_1 === other.order_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Group');
    DayTotalsPage$render$GroupClass = $;
  }
  return DayTotalsPage$render$GroupClass;
}
function render$groupOf(grouping, f, families, locations, providers, p) {
  var tmp;
  switch (grouping.ordinal_1) {
    case 1:
      // Inline function 'kotlin.let' call

      var it = f.ageGroupOf_ek8y4_k$(p);
      tmp = new (DayTotalsPage$render$Group())(it.displayName_1, null, it.ordinal_1);
      break;
    case 0:
      tmp = new (DayTotalsPage$render$Group())(getValue(families, new (ID())(p.family_1)).get_distinctName_5wyy9c_k$(), f.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, setOf(new (ID())(p.family_1))));
      break;
    case 2:
      tmp = new (DayTotalsPage$render$Group())(getValue(locations, new (ID_0())(p.location_1)).name_1, f.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, setOf(new (ID_0())(p.location_1))));
      break;
    case 3:
      tmp = new (DayTotalsPage$render$Group())(getValue(providers, new (ID_1())(p.provider_1)).name_1, f.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, VOID, setOf(new (ID_1())(p.provider_1))));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function DayTotalsPage$render$slambda$slambda$slambda($api, $totals) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_employer_c2djlo_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Employer()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id(it);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = $totals.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = element.employers_1.get_keys_wop4xp_k$();
      addAll(destination, list);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function DayTotalsPage$render$slambda$slambda$slambda_0($api, $totals) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_grant_is33zn_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Grant()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_0(it);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = $totals.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = element.grants_1.get_keys_wop4xp_k$();
      addAll(destination, list);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function DayTotalsPage$render$slambda$slambda$slambda_1($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_family_d7lffx_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_1(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID())(item.family_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function DayTotalsPage$render$slambda$slambda$slambda_2($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_careLocation_drerzj_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_2(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID_0())(item.location_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function DayTotalsPage$render$slambda$slambda$slambda_3($api, $placements) {
  return constructCallableReference(($this$async, $completion) => orPromise($completion, function *($completion) {
    var tmp = $api.get_careProvider_y0cmmt_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp_1 = get__id_3(it);
    // Inline function 'kotlin.collections.map' call
    var this_0 = $placements;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID_1())(item.provider_1);
      destination.add_utx5q5_k$(tmp$ret$7);
    }
    var tmp$ret$4 = xDataClassPathInsideSet(tmp_1, toSet(destination));
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    return yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
  }), 1);
}
function DayTotalsPage$render$slambda$slambda$lambda(it) {
  return it.get_key_18j28a_k$().order_1;
}
function DayTotalsPage$render$slambda$slambda$lambda_0(it) {
  return it.get_key_18j28a_k$().label_1;
}
function DayTotalsPage$render$slambda$slambda$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.name_1;
  var tmp$ret$2 = b.name_1;
  return compareValues(tmp, tmp$ret$2);
}
function DayTotalsPage$render$slambda$slambda$lambda_2($employer) {
  return (it) => it.employers_1.get_wei43m_k$(new (ID_2())($employer._id_1));
}
function DayTotalsPage$render$slambda$slambda$lambda_3($employer) {
  return (it) => it.copy$default_x0hf9x_k$(VOID, VOID, setOf(new (ID_2())($employer._id_1)));
}
function DayTotalsPage$render$slambda$slambda$lambda_4(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.name_1;
  var tmp$ret$2 = b.name_1;
  return compareValues(tmp, tmp$ret$2);
}
function DayTotalsPage$render$slambda$slambda$lambda_5($grant) {
  return (it) => it.grants_1.get_wei43m_k$(new (ID_3())($grant._id_1));
}
function DayTotalsPage$render$slambda$slambda$lambda_6($grant) {
  return (it) => it.copy$default_x0hf9x_k$(VOID, VOID, VOID, setOf(new (ID_3())($grant._id_1)));
}
function DayTotalsPage$render$slambda$slambda($api, $totals, $grouping, $f) {
  return constructCallableReference(($this$coroutineScope, $completion) => orPromise($completion, function *($completion) {
    var employersAsync = async($this$coroutineScope, VOID, VOID, DayTotalsPage$render$slambda$slambda$slambda($api, $totals));
    var grantsAsync = async($this$coroutineScope, VOID, VOID, DayTotalsPage$render$slambda$slambda$slambda_0($api, $totals));
    var tmp = $api.get_childPlacement_o77pq_k$();
    var tmp2 = 2147483647;
    // Inline function 'com.lightningkite.services.database.Query' call
    // Inline function 'kotlin.collections.listOf' call
    var orderBy = emptyList();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
    var tmp$ret$3 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$3);
    var tmp$ret$4 = xDataClassPathInsideSet(get__id_4(it), $totals.get_keys_wop4xp_k$());
    var tmp$ret$0 = new (Query())(tmp$ret$4, orderBy, 0, tmp2);
    var placements = yield* tmp.query_o986pg_k$(tmp$ret$0, $completion);
    var familiesAsync = async($this$coroutineScope, VOID, VOID, DayTotalsPage$render$slambda$slambda$slambda_1($api, placements));
    var locationsAsync = async($this$coroutineScope, VOID, VOID, DayTotalsPage$render$slambda$slambda$slambda_2($api, placements));
    var providersAsync = async($this$coroutineScope, VOID, VOID, DayTotalsPage$render$slambda$slambda$slambda_3($api, placements));
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = yield* familiesAsync.await_4rdzbx_k$($completion);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$7 = new (ID())(element._id_1);
      destination.put_4fpzoq_k$(tmp$ret$7, element);
    }
    var families = destination;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = yield* locationsAsync.await_4rdzbx_k$($completion);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_0);
    var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$10 = new (ID_0())(element_0._id_1);
      destination_0.put_4fpzoq_k$(tmp$ret$10, element_0);
    }
    var locations = destination_0;
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = yield* providersAsync.await_4rdzbx_k$($completion);
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity_1);
    var _iterator__ex2g4s_1 = this_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
      var tmp$ret$13 = new (ID_1())(element_1._id_1);
      destination_1.put_4fpzoq_k$(tmp$ret$13, element_1);
    }
    var providers = destination_1;
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    var _iterator__ex2g4s_2 = placements.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
      var key = render$groupOf($grouping, $f, families, locations, providers, element_2);
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_2.get_wei43m_k$(key);
      var tmp_1;
      if (value == null) {
        var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        destination_2.put_4fpzoq_k$(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var list = tmp_1;
      list.add_utx5q5_k$(element_2);
    }
    var tmp_2 = destination_2.get_entries_p20ztl_k$();
    var tmp_3 = DayTotalsPage$render$slambda$slambda$lambda;
    // Inline function 'kotlin.collections.map' call
    var this_3 = sortedWith(tmp_2, compareBy([tmp_3, DayTotalsPage$render$slambda$slambda$lambda_0]));
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_3, 10));
    var _iterator__ex2g4s_3 = this_3.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_3.next_20eer_k$();
      // Inline function 'kotlin.collections.component1' call
      var group = item.get_key_18j28a_k$();
      // Inline function 'kotlin.collections.component2' call
      var ps = item.get_value_j01efc_k$();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(ps, 10));
      var _iterator__ex2g4s_4 = ps.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
        var item_0 = _iterator__ex2g4s_4.next_20eer_k$();
        var tmp$ret$26 = getValue($totals, new (ID_4())(item_0._id_1));
        destination_4.add_utx5q5_k$(tmp$ret$26);
      }
      // Inline function 'kotlin.collections.fold' call
      var accumulator = new (BilledDayTotals())();
      var _iterator__ex2g4s_5 = destination_4.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_5.hasNext_bitz1p_k$()) {
        var element_3 = _iterator__ex2g4s_5.next_20eer_k$();
        accumulator = accumulator.plus_8jdhal_k$(element_3);
      }
      var tmp$ret$27 = accumulator;
      var tmp$ret$21 = new (Row())(group.label_1, tmp$ret$27, group.drillDown_1);
      destination_3.add_utx5q5_k$(tmp$ret$21);
    }
    var rows = destination_3;
    var tmp0 = $totals.get_values_ksazhn_k$();
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = new (BilledDayTotals())();
    var _iterator__ex2g4s_6 = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_6.hasNext_bitz1p_k$()) {
      var element_4 = _iterator__ex2g4s_6.next_20eer_k$();
      accumulator_0 = accumulator_0.plus_8jdhal_k$(element_4);
    }
    var tmp$ret$29 = accumulator_0;
    var total = new (Row())('Total', tmp$ret$29, $f);
    // Inline function 'kotlin.collections.sortedBy' call
    var this_4 = yield* employersAsync.await_4rdzbx_k$($completion);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_4 = DayTotalsPage$render$slambda$slambda$lambda_1;
    var tmp$ret$32 = new (sam$kotlin_Comparator$0())(tmp_4);
    // Inline function 'kotlin.collections.map' call
    var this_5 = sortedWith(this_4, tmp$ret$32);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_5, 10));
    var _iterator__ex2g4s_7 = this_5.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_7.hasNext_bitz1p_k$()) {
      var item_1 = _iterator__ex2g4s_7.next_20eer_k$();
      var tmp_5 = DayTotalsPage$render$slambda$slambda$lambda_2(item_1);
      var tmp$ret$35 = new (Payer())(item_1.name_1, tmp_5, DayTotalsPage$render$slambda$slambda$lambda_3(item_1));
      destination_5.add_utx5q5_k$(tmp$ret$35);
    }
    var tmp_6 = destination_5;
    // Inline function 'kotlin.collections.sortedBy' call
    var this_6 = yield* grantsAsync.await_4rdzbx_k$($completion);
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_7 = DayTotalsPage$render$slambda$slambda$lambda_4;
    var tmp$ret$37 = new (sam$kotlin_Comparator$0())(tmp_7);
    // Inline function 'kotlin.collections.map' call
    var this_7 = sortedWith(this_6, tmp$ret$37);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_6 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_7, 10));
    var _iterator__ex2g4s_8 = this_7.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_8.hasNext_bitz1p_k$()) {
      var item_2 = _iterator__ex2g4s_8.next_20eer_k$();
      var tmp_8 = DayTotalsPage$render$slambda$slambda$lambda_5(item_2);
      var tmp$ret$40 = new (Payer())(item_2.name_1, tmp_8, DayTotalsPage$render$slambda$slambda$lambda_6(item_2));
      destination_6.add_utx5q5_k$(tmp$ret$40);
    }
    var payers = plus(tmp_6, destination_6);
    return new (Report())(plus_0(rows, total), payers);
  }), 1);
}
function DayTotalsPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.filter_1;
    var f = yield* await_0(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.groupBy_1;
    var grouping = yield* await_0(this_1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_currentSessionNotNull();
    var api = (yield* await_1(this_2, $completion)).api_1;
    // Inline function 'kotlin.collections.mapKeys' call
    var this_3 = yield* api.get_singleChildDay_52scz3_k$().totalsByPlacement_39jjrf_k$(f.toCondition_oj74tc_k$(), $completion);
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(this_3.get_size_woubt6_k$()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = this_3.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp = new (ID_4())(_ID___init__impl__k1lb7e(Companion_getInstance().parse_pc1q8p_k$(element.get_key_18j28a_k$())));
      var tmp$ret$7 = element.get_value_j01efc_k$();
      destination.put_4fpzoq_k$(tmp, tmp$ret$7);
    }
    var totals = destination;
    return yield* coroutineScope(DayTotalsPage$render$slambda$slambda(api, totals, grouping, f), $completion);
  }), 1);
}
function DayTotalsPage$render$lambda$slambda($report, this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $report;
    var r = yield* await_1(this_0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.groupBy_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var tmp = listOf_0([tmp$ret$1.displayName_1, 'Days', 'Cost of care']);
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = r.payers_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = listOf_0([element.name_1, element.name_1 + ' admin charge']);
      addAll(destination, list);
    }
    var header = plus_0(plus(tmp, destination), 'Family');
    // Inline function 'kotlin.collections.map' call
    var this_2 = r.rows_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_0 = this_2.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp_0 = listOf_0([item.label_1, item.totals_1.days_1.toString(), Cents__toDouble_impl_mg3etm(item.totals_1.price_1).toString()]);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_0 = r.payers_1;
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
        var paid = element_0.paid_1(item.totals_1);
        var tmp1_safe_receiver = paid == null ? null : paid.amount_1;
        var tmp_1;
        var tmp_2 = tmp1_safe_receiver;
        if ((tmp_2 == null ? null : new (Cents())(tmp_2)) == null) {
          tmp_1 = null;
        } else {
          tmp_1 = Cents__toDouble_impl_mg3etm(tmp1_safe_receiver);
        }
        var tmp2_safe_receiver = tmp_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.toString();
        var tmp_3 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
        var tmp5_safe_receiver = paid == null ? null : paid.administrativeCharge_1;
        var tmp_4;
        var tmp_5 = tmp5_safe_receiver;
        if ((tmp_5 == null ? null : new (Cents())(tmp_5)) == null) {
          tmp_4 = null;
        } else {
          tmp_4 = Cents__toDouble_impl_mg3etm(tmp5_safe_receiver);
        }
        var tmp6_safe_receiver = tmp_4;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.toString();
        var list_0 = listOf_0([tmp_3, tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs]);
        addAll(destination_1, list_0);
      }
      var tmp$ret$7 = plus_0(plus(tmp_0, destination_1), Cents__toDouble_impl_mg3etm(item.totals_1.paidByFamily_1).toString());
      destination_0.add_utx5q5_k$(tmp$ret$7);
    }
    var rows = destination_0;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_3 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
    appendCsvRows(this_3, plus_1(sequenceOf(header), asSequence(rows)));
    var csv = this_3.toString();
    var tmp_6 = $this_exportButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = this$0.filter_1;
    var tmp_7 = (yield* await_0(this_4, $completion)).start_1.toString();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = this$0.filter_1;
    var tmp$ret$15 = yield* await_0(this_5, $completion);
    yield* download(tmp_6, 'billed-day-totals-' + tmp_7 + '-' + tmp$ret$15.endInclusive_1.toString() + '.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function DayTotalsPage$render$lambda(it) {
  return it.displayName_1;
}
function DayTotalsPage$render$lambda$lambda$lambda($this$tableWithSticky, it) {
  return $this$tableWithSticky;
}
function DayTotalsPage$render$lambda$lambda$lambda_0($this$custom, row) {
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Link())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = Link$_get_to_$ref_jq7esp(element);
  var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(row).drillDown_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var f = tmp0_safe_receiver;
      tmp = () => {
        // Inline function 'kotlin.apply' call
        var this_0 = new (SingleDaysPage())();
        this_0.filter_1.set_value_v1vabv_k$(f);
        return this_0;
      };
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(row).label_1);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function DayTotalsPage$render$lambda$lambda$lambda_1($this$text) {
  return 'Days';
}
function DayTotalsPage$render$lambda$lambda$lambda_2($this$text, it) {
  return it.totals_1.days_1.toString();
}
function DayTotalsPage$render$lambda$lambda$lambda_3($this$text) {
  return 'Cost of care';
}
function DayTotalsPage$render$lambda$lambda$lambda_4($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.totals_1.price_1);
}
function DayTotalsPage$render$lambda$lambda$lambda_5($payer) {
  return ($this$custom) => $payer.name_1;
}
function DayTotalsPage$render$lambda$lambda$lambda_6($payer) {
  return ($this$custom, row) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.link' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (Link())($this$custom.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$custom.willAddChild_hz2iwc_k$(element);
    var tmp = KMutableProperty0();
    var tmp_0 = Link$_get_to_$ref_jq7esp(element);
    var tmp_1 = getPropertyCallableRef('to', 0, tmp, tmp_0, Link$_set_to_$ref_i9gu5x(element));
    element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
      var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(row).drillDown_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var f = tmp0_safe_receiver;
        tmp = () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (SingleDaysPage())();
          this_0.filter_1.set_value_v1vabv_k$($payer.narrow_1(f));
          return this_0;
        };
      }
      return tmp;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = themed(element, LabelGapSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element_0.willAddChild_hz2iwc_k$(element_1);
    element_1.set_align_ypalx0_k$(Align_End_getInstance());
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
    element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => {
      var tmp0_safe_receiver = $payer.paid_1($this$invoke.invoke_r7m7el_k$(row).totals_1);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.amount_1;
      var tmp;
      var tmp_0 = tmp1_safe_receiver;
      if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
        tmp = null;
      } else {
        tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
      }
      var tmp2_elvis_lhs = tmp;
      return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    });
    element_1.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (TextView())(element_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_themeChoice_py59um_k$(element_2.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
    element_2.set_align_ypalx0_k$(Align_End_getInstance());
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_2);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_2));
    element_2.invoke_bnq13k_k$(tmp_7, ($this$invoke) => {
      var tmp0_safe_receiver = $payer.paid_1($this$invoke.invoke_r7m7el_k$(row).totals_1);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.administrativeCharge_1;
      var tmp;
      var tmp_0 = tmp1_safe_receiver;
      if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
        tmp = null;
      } else {
        var tmp_1 = tmp1_safe_receiver;
        // Inline function 'kotlin.takeIf' call
        var this_0 = tmp_1 == null ? null : new (Cents())(tmp_1);
        var tmp_2;
        var it = this_0.inCents_1;
        if (!(_Cents___get_inCents__impl__osbjn(it) === 0n)) {
          tmp_2 = this_0;
        } else {
          tmp_2 = null;
        }
        var tmp_3 = tmp_2;
        tmp = tmp_3 == null ? null : tmp_3.inCents_1;
      }
      var tmp2_safe_receiver = tmp;
      var tmp_4;
      var tmp_5 = tmp2_safe_receiver;
      if ((tmp_5 == null ? null : new (Cents())(tmp_5)) == null) {
        tmp_4 = null;
      } else {
        var tmp_6 = tmp2_safe_receiver;
        // Inline function 'kotlin.let' call
        var it_0 = (tmp_6 == null ? null : new (Cents())(tmp_6)).inCents_1;
        tmp_4 = 'Admin: + ' + Cents__toString_impl_ko5hxm(it_0) + ' ';
      }
      var tmp3_elvis_lhs = tmp_4;
      return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    });
    element_2.onStartup_vrxh3i_k$();
    element_0.addChild_2qpft2_k$(element_2);
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    $this$custom.addChild_2qpft2_k$(element);
    return Unit_instance;
  };
}
function DayTotalsPage$render$lambda$lambda$lambda_7($this$text) {
  return 'Family';
}
function DayTotalsPage$render$lambda$lambda$lambda_8($this$text, it) {
  return Cents__toString_impl_ko5hxm(it.totals_1.paidByFamily_1);
}
function DayTotalsPage$render$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var report = $next;
    var tmp = _Constant___init__impl__v45mub(report.rows_1);
    var tmp_0 = DayTotalsPage$render$lambda$lambda$lambda;
    var tmp_1 = get_rem(4);
    var tmp_2 = Companion_instance_0;
    var tmp_3 = ($this$custom) => $this$custom.invoke_r7m7el_k$(this$0.groupBy_1).displayName_1;
    var tmp_4 = get_rem(16);
    var tmp_5 = _Constant___init__impl__v45mub(listOf(tmp_2.custom_dlzbwd_k$(tmp_3, tmp_4, DayTotalsPage$render$lambda$lambda$lambda_0)));
    var tmp_6 = Companion_instance_0;
    var tmp_7 = DayTotalsPage$render$lambda$lambda$lambda_1;
    var tmp_8 = get_rem(5);
    var tmp_9 = tmp_6.text_otwg0k_k$(tmp_7, tmp_8, DayTotalsPage$render$lambda$lambda$lambda_2);
    var tmp_10 = Companion_instance_0;
    var tmp_11 = DayTotalsPage$render$lambda$lambda$lambda_3;
    var tmp_12 = get_rem(9);
    var tmp_13 = listOf_0([tmp_9, tmp_10.text_otwg0k_k$(tmp_11, tmp_12, DayTotalsPage$render$lambda$lambda$lambda_4)]);
    // Inline function 'kotlin.collections.map' call
    var this_0 = report.payers_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp_14 = Companion_instance_0;
      var tmp_15 = DayTotalsPage$render$lambda$lambda$lambda_5(item);
      var tmp_16 = get_rem(15);
      var tmp$ret$3 = tmp_14.custom_dlzbwd_k$(tmp_15, tmp_16, DayTotalsPage$render$lambda$lambda$lambda_6(item));
      destination.add_utx5q5_k$(tmp$ret$3);
    }
    var tmp_17 = plus(tmp_13, destination);
    var tmp_18 = Companion_instance_0;
    var tmp_19 = DayTotalsPage$render$lambda$lambda$lambda_7;
    var tmp_20 = get_rem(9);
    tableWithSticky($this$swap, new (Constant())(tmp), tmp_0, tmp_1, new (Constant())(tmp_5), new (Constant())(_Constant___init__impl__v45mub(plus_0(tmp_17, tmp_18.text_otwg0k_k$(tmp_19, tmp_20, DayTotalsPage$render$lambda$lambda$lambda_8)))));
    return Unit_instance;
  };
}
function DayTotalsPage$render$lambda_0($this$shownWhen) {
  return get_current(Companion_instance_1).equals(Platform_Web_getInstance());
}
var DayTotalsPageClass;
function DayTotalsPage() {
  if (DayTotalsPageClass === VOID) {
    class $ {
      constructor() {
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (ReportFilters())());
        this.groupBy_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(DayGrouping_Family_getInstance());
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Billed Day Totals'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.fullWidthPage' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        var report_0 = rememberSuspending(VOID, VOID, VOID, DayTotalsPage$render$slambda(this));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_1 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_1.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_atBottomStart(element_0);
        var tmp$ret$10 = weight(this_2, 1.0);
        h1(tmp$ret$10, 'Billed Day Totals');
        reportFilterMenu(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export billed day totals', VOID, VOID, VOID, VOID, VOID, DayTotalsPage$render$lambda$slambda(report_0, this, $this$exportButton)));
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_0);
        reportFilterBar(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Group by';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        element.willAddChild_hz2iwc_k$(element_1);
        element_1.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_3 = themed(element_1, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Select())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        var tmp = _Constant___init__impl__v45mub(get_entries());
        element_2.bind_64a41i_k$(this.groupBy_1, new (Constant())(tmp), DayTotalsPage$render$lambda);
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        element_1.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element.willAddChild_hz2iwc_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_4 = element_3;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_4, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(report_0);
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_1().Fade_1;
              this_4.swap_26x94b_k$(tmp_0, DayTotalsPage$render$lambda$lambda(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_3.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_5 = shownWhen(element, VOID, VOID, DayTotalsPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Space())(this_5.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'DayTotalsPage', DayTotalsPage, VOID, [Page()]);
    DayTotalsPageClass = $;
  }
  return DayTotalsPageClass;
}
function DayGrouping_Family_getInstance() {
  static_init();
  return DayGrouping_Family_instance;
}
function DayGrouping_AgeGroup_getInstance() {
  static_init();
  return DayGrouping_AgeGroup_instance;
}
function DayGrouping_Location_getInstance() {
  static_init();
  return DayGrouping_Location_instance;
}
function DayGrouping_Provider_getInstance() {
  static_init();
  return DayGrouping_Provider_instance;
}
//region block: exports
export {
  DayGrouping_Family_getInstance as DayGrouping_Family_getInstance13nqmghrlrmsx,
  DayGrouping_Location_getInstance as DayGrouping_Location_getInstancedo19cuuiy558,
  DayGrouping_Provider_getInstance as DayGrouping_Provider_getInstance3entcec0uiq20,
  DayGrouping as DayGrouping3jwege0metqlv,
  DayTotalsPage as DayTotalsPage3tkd9ei9dl3us,
};
//endregion

//# sourceMappingURL=DayTotalsPage.mjs.map
